(function reservations($, Adzuki)
{
	"use strict";

	var $modal = $(".modal");

	$(document).ready(function documentReady()
	{
		var reservation_pages       = ['Reservations/manage', 'Reservations/viewCanceled'],
		    component_details_pages = ['Reservations/addTravelComponentDetails', 'Reservations/editTravelComponentDetails'];

		// for "sneek peek" on reservation list
		Adzuki.onload('Reservations/index', function onload()
		{
			$('.reservation-peek').on('click', '.reservation-details', function showReservationDetails(e)
			{
				e.preventDefault();
				$modal.find('.modal-body').text('Loading reservation details...');
				$modal.find('.modal-title').text('Reservation Details');
				$modal.modal('show');

				Adzuki.Ajax.get('/Reservations/reservationDetailsModal/'+$(this).data('reservation-id'))
				.then(function showDetails(data) {
					$modal.find('.modal-body').html(data);
				});
			});
		});

		// reservation overview screen
		Adzuki.onload(reservation_pages, function onload()
		{
			var modal_title   = $('#popup_comment').data("modal-title"),
				modal_body    = $('#popup_comment').data("modal-body");

			if ($('#popup_comment').length) {

				$modal.addClass('wide');
				$modal.find('.modal-body').html(modal_body);
				$modal.find('.modal-title').text(modal_title);

				$modal.modal('show');
			}

			$("button.component-url").on('click', function loadUrl(e)
			{
				var $self = $(this),
				    url  = $self.data('url');

				e.preventDefault();

				document.location = Adzuki.base_uri + '/Reservations/manageComponents/' + url;
			});

			$('.unavailable').click(function showUnavailable(e) {
				e.preventDefault();

				Adzuki.StatusMessage(null, 'This feature is not yet available.', 'Unavailable');
			});

			// change reservation type
			$('.reservation-type').click(function showReservationTypeDropDown(e) {
				e.preventDefault();

				$('.current-reservation-type').addClass('hidden');
				$('.reservation-type-list').removeClass('hidden');
			});

			$('.reset-reservation-type-selection').click(function resetBookingAgentSelection(e) {
				e.preventDefault();

				$('.reservation-type-list').addClass('hidden');
				$('.current-reservation-type').removeClass('hidden');
			});

			$('#reservation-type-selection').change(function changeReservationType() {
				var reservation_id = $(this).data("reservation-id"),
					type           = $(this).val(),
					type_name      = $('#reservation-type-selection option:selected').text();

				$('.reset-reservation-type-selection').addClass('hidden');
				$('.reservation-type-working').removeClass('hidden');

				Adzuki.Ajax.get('/Reservations/updateReservationType/' + reservation_id + '/' + type)
					.then(function _updateReservationType(html) {
						$('.current-reservation-type-name').html(type_name);

						$('.reservation-type-list').addClass('hidden');
						$('.current-reservation-type').removeClass('hidden');
						$('.reservation-type-working').addClass('hidden');
						$('.reset-reservation-type-selection').removeClass('hidden');
				});
			});

			// change booking agent
			$('.booking-agent').click(function showBookingAgentDropDown(e) {
				e.preventDefault();

				$('.current-booking-agent').addClass('hidden');
				$('.agent-list').removeClass('hidden');
			});

			$('.reset-booking-agent-selection').click(function resetBookingAgentSelection(e) {
				e.preventDefault();

				$('.agent-list').addClass('hidden');
				$('.current-booking-agent').removeClass('hidden');
			});

			$('#booking-agent-selection').change(changeBookingAgent);

			// change primary vendor
			$('.primary-vendor').click(function showPrimaryVendorDropDown(e) {
				e.preventDefault();

				$('.current-primary-vendor').addClass('hidden');
				$('.primary-vendor-list').removeClass('hidden');
			});

			$('.reset-primary-vendor-selection').click(function resetPrimaryVendorSelection(e) {
				e.preventDefault();

				$('.primary-vendor-list').addClass('hidden');
				$('.current-primary-vendor').removeClass('hidden');
			});

			$('#primary-vendor-selection').change(changePrimaryVendor);

			// econnect sync link
			$('.synch-now').click(function showEconnectSync(e) {
				e.preventDefault();
				synchNow($(this));
			});

			// show insurance policy
			$('.print-policy').click(function showInsurancePolicy(event)
			{
				var modal_title   = $(this).data('modal-title');
				var iframe_src    = $(this).data('iframe-src');
				var iframe_height = $(this).data('iframe-height') || 500;
				var iframe_width  = $(this).data('iframe-width') || '100%';

				event.preventDefault();

				$modal.addClass('wide');

				$modal.find('iframe').attr({
					src   : iframe_src,
					height: iframe_height,
					width : iframe_width
				});

				$modal.find('.modal-title').text(modal_title);
				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});

			// itinerary view
			$('.reservation-itinerary').click(function showItinerary(e) {
				var itinerary_id = $(this).data("itinerary-id");

				e.preventDefault();

				Adzuki.Ajax.get('/Itineraries/details/' + itinerary_id)
					.then(function _updateBookingAgent(html) {
					$modal.addClass('wide');
					$modal.find('.modal-title').text("Itinerary Details");
					$modal.find('.modal-body').html(html);

					$modal.on('hidden.bs.modal', function _restoreModal() {
						$modal.removeClass('wide').off('hidden.bs.modal');
					}).modal('show');
				});
			});

			// all-inclusive property view
			$('.ai-property').click(function allInclusiveModal(e) {
				var property_id = $(this).data('id');

				e.preventDefault();

				$(".modal-dialog").addClass('modal-lg');
				$modal.find('.modal-body').text('Loading property...');

				Adzuki.Ajax.get('/AllInclusiveProperties/view/' + property_id + '/1')
					.then(function _displayAllInclusive(html) {
					$modal.addClass('wide');
					$modal.find('.modal-title').text("Resort Details");
					$modal.find('.modal-body').html(html);

					$modal.on('hidden.bs.modal', function _restoreModal() {
						$modal.removeClass('wide').off('hidden.bs.modal');
					}).modal('show');
				});
			});

			// view the details of an amenity
			$('.view-amenity-details').on('click', _viewAmenityDetails);

			markTravel();

			requestRoyalty();

			copyToClipboard();
		}, false);

		// components screen
		Adzuki.onload('Reservations/manageComponents', function onload()
		{
			$("a.info-link").on('click', function showInfo(e)
			{
				var $self = $(this),
				    body  = $self.data('content') || $($self.data('modal-id')).html(),
				    title = $self.text();

				if ($self.data('modal-title')) {
					title = $self.data('modal-title');
				}

				e.preventDefault();
				$modal.find('.modal-title').text(title);
				$modal.find('.modal-body').html(body);
				$modal.modal('show');
			});

			// show details
			$("button.details-link").on('click', function showInfo(e)
			{
				var $self = $(this),
				    component_id  = $self.data('id');

				e.preventDefault();

				$self.addClass('current');
				$("#details-" + component_id).removeClass('hidden');

				$("#btn-pricing-" + component_id).removeClass('current');
				$("#pricing-" + component_id).addClass('hidden');

				$("#btn-payments-" + component_id).removeClass('current');
				$("#payments-" + component_id).addClass('hidden');
			});

			// show pricing & commission
			$("button.pricing-link").on('click', function showInfo(e)
			{
				var $self = $(this),
				    component_id  = $self.data('id');

				e.preventDefault();

				$self.addClass('current');
				$("#pricing-" + component_id).removeClass('hidden');

				$("#btn-details-" + component_id).removeClass('current');
				$("#details-" + component_id).addClass('hidden');

				$("#btn-payments-" + component_id).removeClass('current');
				$("#payments-" + component_id).addClass('hidden');
			});

			// show payments
			$("button.payments-link").on('click', function showInfo(e)
			{
				var $self = $(this),
				    component_id  = $self.data('id');

				e.preventDefault();

				$self.addClass('current');
				$("#payments-" + component_id).removeClass('hidden');

				$("#btn-details-" + component_id).removeClass('current');
				$("#details-" + component_id).addClass('hidden');

				$("#btn-pricing-" + component_id).removeClass('current');
				$("#pricing-" + component_id).addClass('hidden');
			});

			// for displaying component comment
			$('.comment').click(function showComment(e) {
				var $self         = $(this),
				    $modal        = $(".modal"),
				    comment_model = $self.data("comment-model"),
				    comment_id    = $self.data("comment-id"),
				    modal_title   = $self.data("modal-title");

				e.preventDefault();

				$modal.addClass('wide');
				$modal.find('.modal-body').text('Loading comment...');

				Adzuki.Ajax.get('/ReservationComments/view/' + comment_model + '/' + comment_id)
					.then(function _showComment(html) {
						$modal.find('.modal-body').html(html);
						$modal.find('[data-toggle^="tooltip"]').tooltip();
				});

				$modal.find('.modal-title').text(modal_title);
				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});

			$('.synch-now').click(function showEconnectSync(e) {
				e.preventDefault();
				synchNow($(this));
			});

			// show insurance policy
			$('.print-policy').click(function showInsurancePolicy(event)
			{
				var modal_title   = $(this).data('modal-title');
				var iframe_src    = $(this).data('iframe-src');
				var iframe_height = $(this).data('iframe-height') || 500;
				var iframe_width  = $(this).data('iframe-width') || '100%';

				event.preventDefault();

				$modal.addClass('wide');

				$modal.find('iframe').attr({
					src   : iframe_src,
					height: iframe_height,
					width : iframe_width
				});

				$modal.find('.modal-title').text(modal_title);
				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});

			// itinerary view
			$('.reservation-itinerary').click(function showItinerary(e) {
				var itinerary_id = $(this).data("itinerary-id");

				e.preventDefault();

				Adzuki.Ajax.get('/Itineraries/details/' + itinerary_id)
					.then(function _updateBookingAgent(html) {
					$modal.addClass('wide');
					$modal.find('.modal-title').text("Itinerary Details");
					$modal.find('.modal-body').html(html);

					$modal.on('hidden.bs.modal', function _restoreModal() {
						$modal.removeClass('wide').off('hidden.bs.modal');
					}).modal('show');
				});
			});

			// all-inclusive property view
			$('.ai-property').click(function allInclusiveModal(e) {
				var property_id = $(this).data('id');

				e.preventDefault();

				$(".modal-dialog").addClass('modal-lg');
				$modal.find('.modal-body').text('Loading property...');

				Adzuki.Ajax.get('/AllInclusiveProperties/view/' + property_id + '/1')
					.then(function _displayAllInclusive(html) {
					$modal.addClass('wide');
					$modal.find('.modal-title').text("Resort Details");
					$modal.find('.modal-body').html(html);

					$modal.on('hidden.bs.modal', function _restoreModal() {
						$modal.removeClass('wide').off('hidden.bs.modal');
					}).modal('show');
				});
			});

			$('.vidanta-toggle').click(function vidantaToggle(e) {
				var $link        = $(this),
					action       = $link.data('action'),
					component_id = $link.data('id');

				e.preventDefault();

				Adzuki.Ajax.get('/Reservations/updateVidanta/' + component_id + '/' + action)
					.then(function updateDom(output) {

					if (action === 'request') {
						$link.parent().addClass('hidden');
						$link.parent().next().removeClass('hidden');

						Adzuki.StatusMessage('Success', 'The Vidanta promotion has been requested for this booking.');
					} else {
						$link.parent().addClass('hidden');
						$link.parent().prev().removeClass('hidden');

						Adzuki.StatusMessage('Success', 'The Vidanta promotion request for this booking has been cancelled.');
					}
				});
			});

			// show details of an amenity/OBC
			$('.view-amenity-details').on('click', _viewAmenityDetails);

			markTravel();

			requestRoyalty();

			copyToClipboard();
		}, false);

		// component details screen
		Adzuki.onload(component_details_pages, function onload()
		{
			var $cubaTravelField     = $('input.cuba-travel'),
			    $travelFormContainer = $('#cuba_travel_form').closest('.form-group');

			if ($cubaTravelField.prop('checked')) {
				$travelFormContainer.removeClass('hidden');
			} else {
				$travelFormContainer.addClass('hidden');
			}

			$cubaTravelField.click(function showCubaTravelForm(e)
			{
				var $self = $(this);

				if ($self.prop('checked')) {
					Adzuki.StatusMessage(
						'default',
						'Please download the below form and send it to your client. Once complete, save it for your records.',
						'Cuba Travel Attestation'
					);

					$travelFormContainer.removeClass('hidden');
				} else {
					$travelFormContainer.addClass('hidden');
				}
			});
		}, false);

		// pricing/commission screen
		Adzuki.onload('Reservations/managePricingCommission', function onload()
		{
			requestRoyalty();
		}, false);

		// payments screen
		Adzuki.onload('Reservations/managePayments', function onload()
		{
			$('.synch-now').click(function showEconnectSync(e) {
				e.preventDefault();
				synchNow($(this));
			});

			requestRoyalty();
		}, false);

		// comments screen
		Adzuki.onload('Reservations/manageComments', function onload()
		{
			$('.comment').click(function showComment(e) {
				var $self         = $(this),
				    $modal        = $(".modal"),
				    comment_model = $self.data("comment-model"),
				    comment_id    = $self.data("comment-id"),
				    modal_title   = $self.data("modal-title");

				e.preventDefault();

				$modal.addClass('wide');
				$modal.find('.modal-body').text('Loading comment...');

				Adzuki.Ajax.get('/ReservationComments/view/' + comment_model + '/' + comment_id)
					.then(function _showComment(html) {
						$modal.find('.modal-body').html(html);
						$modal.find('[data-toggle^="tooltip"]').tooltip();
				});

				$modal.find('.modal-title').text(modal_title);
				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});
		});

		// emails screen
		Adzuki.onload('Reservations/manageEmails', function onload()
		{
			$('.sent-email, .queued-email').click(function showEmail(e) {
				var $self          = $(this),
				    $modal         = $(".modal"),
				    modal_title    = $self.data("modal-title"),
				    iframe_src     = $self.data("iframe-src"),
				    iframe_height  = $self.data("iframe-height") || 500,
				    iframe_width   = $self.data("iframe-width") || '100%';

				e.preventDefault();

				$modal.addClass('wide');

				$modal.find('iframe').attr({
					src   : iframe_src,
					height: iframe_height,
					width : iframe_width
				});

				$modal.find('.modal-title').text(modal_title);
				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});
		});

		// insurance screen
		Adzuki.onload('Reservations/manageInsurance', function onload()
		{
			$('.view-quote').click(function showInsuranceQuote(event)
			{
				var modal_title   = $(this).data('modal-title');
				var iframe_src    = $(this).data('iframe-src');
				var iframe_height = $(this).data('iframe-height') || 500;
				var iframe_width  = $(this).data('iframe-width') || '100%';

				event.preventDefault();

				$modal.addClass('wide');

				$modal.find('iframe').attr({
					src   : iframe_src,
					height: iframe_height,
					width : iframe_width
				});

				$modal.find('.modal-title').text(modal_title);
				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.find('iframe').attr({
						src: ''
					});
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});
		});

		// post reservation payment
		Adzuki.onload('Reservations/postReservationPayment', function onload()
		{
			$('.vendor-choice').click(function gotoPaymentScreen(e) {
				var reservation_vendor_id = $(this).data('reservation-vendor-id');

				e.preventDefault();

				document.location = Adzuki.base_uri + '/Reservations/postPayment/' + reservation_vendor_id;
			});
		});

		// schedule reservation payment
		Adzuki.onload('Reservations/scheduleReservationPayment', function onload()
		{
			$('.vendor-choice').click(function gotoPaymentScreen(e) {
				var reservation_vendor_id = $(this).data('reservation-vendor-id');

				e.preventDefault();

				document.location = Adzuki.base_uri + '/Reservations/schedulePayment/' + reservation_vendor_id;
			});
		});

		// pricing/commission screen
		Adzuki.onload('Reservations/managePricingCommission', function onload()
		{
			$('.synch-now').click(function showEconnectSync(e) {
				e.preventDefault();
				synchNow($(this));
			});
		});

		// booking confirmation screen
		Adzuki.onload('CruiseBooking/bookingConfirmation', function onload()
		{
			console.log('readytosync');
			$('.synch-now').click(function showEconnectSync(e) {
				e.preventDefault();
				synchNow($(this));
			});
		}, false);

		// manage attachments screen
		Adzuki.onload('Reservations/manageAttachments', function onload()
		{
			$('.task-details').off().on('click', _openTaskDetails);
		});

		// manage tasks screen
		Adzuki.onload('Reservations/manageTasks', function onload()
		{
			Adzuki.TaskManager.loadEntityTasks('reservation');
		});

		// manage texts screen
		Adzuki.onload('Reservations/manageTexts', function onload() {
			$('.view-text-message').on('click', _viewTextMessage);
		});

		// manage amenities OBC screen
		Adzuki.onload('Reservations/manageAmenities', function onload() {
			$('.view-amenity-details').on('click', _viewAmenityDetails);
		});
	});

	function _openTaskDetails(e)
	{
		var $anchor_elem = $(this);

		e.preventDefault();

		Adzuki.TaskManager.openTaskDetails($anchor_elem);
	}

	function synchNow($self) {
		var component_id          = $self.data('id'),
		    reservation_vendor_id = $self.data('vendor-id'),
		    update_action         = ((typeof $self.data('update-action') === 'undefined') ? '0' : $self.data('update-action'));

		Adzuki.Ajax.get('/CruiseBooking/sync')
			.then(function _showSync(html) {
				$modal.find('.modal-body').html(html);
				$modal.find('[data-toggle^="tooltip"]').tooltip();
		});

		Adzuki.Ajax.get('/CruiseBooking/syncBooking/' + component_id + '/' + update_action)
			.then(function _syncBooking(response) {
				if (response.return_value === 'matchPassengers') {
					window.location.href = Adzuki.base_uri + '/CruiseBooking/matchPassengers';
				} else if (response.return_value === 'editTravelPricing') {
					window.location.href = Adzuki.base_uri + '/Reservations/editTravelPricing/' + reservation_vendor_id;
				} else if (response.return_value === 'updateBooking') {
					window.location.href = Adzuki.base_uri + '/CruiseBooking/updateBooking/' + component_id + '/' + update_action + '/1';
				} else {
					location.reload();
				}
		});

		$modal.find('.modal-title').text("Synchronizing Booking");
		$('.modal-footer').addClass('hidden');

		$modal.on('hidden.bs.modal', function _restoreModal() {
			$('.modal-footer').removeClass('hidden');
		}).modal({
			backdrop: 'static',
			keyboard: false,
		});
	}

	function changeBookingAgent() {
		var reservation_id = $(this).data("reservation-id"),
			agent_id       = $(this).val(),
			agent_name     = $('#booking-agent-selection option:selected').text();

		$('.reset-booking-agent-selection').addClass('hidden');
		$('.booking-agent-working').removeClass('hidden');

		Adzuki.Ajax.get('/Reservations/updateBookingAgent/' + reservation_id + '/' + agent_id)
			.then(function _updateBookingAgent(html) {
				$('.current-booking-agent-name').html(agent_name);
				$('#booking-agent-selection').replaceWith(html);
				$('#booking-agent-selection').change(changeBookingAgent);

				$('.agent-list').addClass('hidden');
				$('.current-booking-agent').removeClass('hidden');
				$('.booking-agent-working').addClass('hidden');
				$('.reset-booking-agent-selection').removeClass('hidden');

				// Replace the agent name shown in the reservation type (if any)
				$('.current-reservation-type-name').html($('.current-reservation-type-name').html().replace(/^(.*? For ).*?$/, function replace(str, match) {
					return match + agent_name;
				}));

				// Replace the agent name shown in the reservation type drop-down
				$('#reservation-type-selection option').each(function iterator() {
					var $option = $(this);

					$option.text($option.text().replace(/^(.*? For ).*?$/, function replace(str, match) {
						return match + agent_name;
					}));
				});
		});
	}

	function changePrimaryVendor() {
		var reservation_id                = $(this).data("reservation-id"),
			primary_reservation_vendor_id = $(this).val(),
			primary_vendor_name           = $('#reservation_vendor_id_' + primary_reservation_vendor_id).data("vendor-name"),
			primary_vendor_confirmation   = $('#reservation_vendor_id_' + primary_reservation_vendor_id).data("vendor-confirmation");

		$('.reset-primary-vendor-selection').addClass('hidden');
		$('.primary-vendor-working').removeClass('hidden');

		Adzuki.Ajax.get('/Reservations/updatePrimaryVendor/' + reservation_id + '/' + primary_reservation_vendor_id)
			.then(function _updatePrimaryVendor(html) {
				$('.current-primary-vendor-name').html(primary_vendor_name);
				$('.current-primary-vendor-confirmation').html(primary_vendor_confirmation);

				$('#primary-vendor-selection').replaceWith(html);
				$('#primary-vendor-selection').change(changePrimaryVendor);

				$('.primary-vendor-list').addClass('hidden');
				$('.current-primary-vendor').removeClass('hidden');
				$('.primary-vendor-working').addClass('hidden');
				$('.reset-primary-vendor-selection').removeClass('hidden');
		});
	}

	function copyToClipboard() {
		$('.copy-to-clipboard').click(function _copyToClipboard(e)
		{
			var content = $(this).data('content'),
			$temp;
			e.preventDefault();

			if (content.length === 0) {
				Adzuki.StatusMessage('Error', 'Please make sure that there is content to copy.');
			} else {
				$temp = $("<textarea>");
				$(this).append($temp);

				$temp.val(content).select();
				document.execCommand("copy");
				$temp.remove();

				Adzuki.StatusMessage('Success', 'The content has been copied to your clipboard.');
			}
		});
	}

	function markTravel()
	{
		$('.mark-travel').click(function markTravel(e) {
			var component_type = $(this).data("component-type"),
				component_id   = $(this).data("component-id"),
				no_depart      = $(this).data("no-depart"),
				title;

			e.preventDefault();

			// if marked as no depart, reset it
			if (no_depart === 1) {
				Adzuki.CustomConfirm({
					title  : 'Decision Time',
					content: 'Are you sure you want to mark this as "Will Travel?" Doing so implies that the traveler is taking the trip. Do you wish to continue?',
					confirm: function confirm() {
						document.location = Adzuki.base_uri + '/Reservations/didTravel/' + component_type + '/' + component_id;
					}
				});
			} else {
				Adzuki.Ajax.get('/Reservations/markTravel/' + component_type + '/' + component_id + '/' + no_depart)
					.then(function _updateBookingAgent(html) {
					title = "Mark Travel as Will Not Travel";

					$modal.find('.modal-title').text(title);
					$modal.find('.modal-body').html(html);
					$modal.on('hidden.bs.modal', function _restoreModal() {
						$modal.removeClass('wide').off('hidden.bs.modal');
					}).modal('show');

					Adzuki.Form.initAjaxForm('MarkTravel');
				});
			}
		});
	}

	function requestRoyalty()
	{
		$('.request-waiver').on('click', function _requestWaiver(e) {
			var reservation_vendor_id = $(this).data('reservation-vendor-id'),
				redirect_section      = $(this).data('redirect-section');

			e.preventDefault();

			Adzuki.CustomConfirm({
				title  : 'Decision Time',
				content: 'Are you sure you want to request a royalty waiver for this component?',
				confirm: function confirm() {
					document.location = Adzuki.base_uri + '/Reservations/requestWavier/' + reservation_vendor_id + '/' + redirect_section;
				}
			});
		});
	}

	function _viewTextMessage(e)
	{
		var text_message_id = $(this).data('reservation-text-message-id');
		var $modal          = $('.modal');

		e.preventDefault();

		$modal.modal('show');
		$modal.find('.modal-title').text('Text Message');
		$modal.find('.modal-body').text('Loading text message...');

		Adzuki.Ajax.get('/ReservationTexts/view/' + text_message_id)
		.then(function viewTextMessage(response) {
				$modal.find('.modal-body').html(response);
		});
	}

	function _viewAmenityDetails(e)
	{
		var component_amenity_id = $(this).data('amenity-id');
		var $modal               = $('.modal');

		e.preventDefault();

		$modal.modal('show');
		$modal.find('.modal-title').text('Amenity Details');
		$modal.find('.modal-body').text('Loading Amenity Details...');

		Adzuki.Ajax.get('/ReservationAmenities/view/' + component_amenity_id)
		.then(function viewAmenityDetails(response) {
			$modal.find('.modal-body').html(response);
		});
	}
}(jQuery, window.Adzuki || {}));
